import { QueryClientConfig } from '@tanstack/react-query';

export const queryClientConfig: QueryClientConfig = {
	defaultOptions: {
		queries: {
			gcTime: 0, // Avoid cache usage with value as zero (renamed from cacheTime in React Query v5)
			refetchOnMount: false,
			refetchOnWindowFocus: false,
			refetchOnReconnect: false,
			retry: false,
		},
	},
};
